/**
 * Owner: Masa Bayu
 * File: advanced-security.ts
 * Date:Time: 2026-09-16 18:34
 * Description: T8 Advanced Experience security — track · E1–E7 slice invariants.
 */
export const QXREAD_T8_TRACK_PROHIBITED = [
    'QXRead → offline prepare without entitlement',
    'QXRead → treat Service Worker as entitlement grant store',
    'QXRead → execute Flip/Media outside QXReader',
    'QXRead → ADAM entry without context/entitlement gate',
    'QXRead → silent sync conflict discard',
    'QXRead → mutate QXP via Advanced Experience',
    'QXRead → invent Entitlement from PWA/offline/ADAM surfaces',
];
export const QXREAD_T8_TRACK_SECURITY = Object.freeze({
    offlineRequiresEntitlement: true,
    serviceWorkerIsNotGrantStore: true,
    flipMediaExecuteInQxReaderOnly: true,
    adamEntryRequiresContextAndEntitlement: true,
    syncConflictsAreNonSilent: true,
    advancedDoesNotMutateQxp: true,
    advancedDoesNotInventEntitlement: true,
    qxReaderRemainsReadingRuntime: true,
    adamDoesNotOwnPublicationTruth: true,
});
export function isT8TrackProhibitedOperation(operation) {
    return QXREAD_T8_TRACK_PROHIBITED.includes(operation);
}
export function assertT8TrackSecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_TRACK_SECURITY)) {
        const expected = QXREAD_T8_TRACK_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8 track security violated: ${key}`);
        }
    }
    return QXREAD_T8_TRACK_SECURITY;
}
export const QXREAD_T8_E1_PROHIBITED = [
    'QXRead → treat PWA install as content unlock',
    'QXRead → treat Service Worker as entitlement grant store',
    'QXRead → prepare OfflinePackage from PWA install surface',
    'QXRead → invent Entitlement from NotificationPreference',
    'QXRead → mutate QXP via PWA install',
    'QXRead → execute Flip/Media from PWA install surface',
];
export const QXREAD_T8_E1_SECURITY = Object.freeze({
    installIsNotContentUnlock: true,
    serviceWorkerIsNotGrantStore: true,
    pwaInstallDoesNotPrepareOfflinePackage: true,
    notificationPreferenceDoesNotInventEntitlement: true,
    pwaDoesNotMutateQxp: true,
    pwaDoesNotExecuteFlipOrMedia: true,
    shellCacheIsNotPublicationTruth: true,
});
export function isT8E1ProhibitedOperation(operation) {
    return QXREAD_T8_E1_PROHIBITED.includes(operation);
}
export function assertT8E1SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_E1_SECURITY)) {
        const expected = QXREAD_T8_E1_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8-E1 security violated: ${key}`);
        }
    }
    return QXREAD_T8_E1_SECURITY;
}
export const QXREAD_T8_E2_PROHIBITED = [
    'QXRead → prepare OfflinePackage without entitlement',
    'QXRead → treat OfflinePackage as entitlement grant',
    'QXRead → mutate QXP via OfflinePackage',
    'QXRead → execute Flip from OfflinePackage surface',
];
export const QXREAD_T8_E2_SECURITY = Object.freeze({
    offlinePackageRequiresEntitlement: true,
    offlinePackageIsNotEntitlementGrant: true,
    offlinePackageDoesNotMutateQxp: true,
    offlinePackageDoesNotExecuteFlip: true,
    purgeOnRevokeRequired: true,
});
export function isT8E2ProhibitedOperation(operation) {
    return QXREAD_T8_E2_PROHIBITED.includes(operation);
}
export function assertT8E2SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_E2_SECURITY)) {
        const expected = QXREAD_T8_E2_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8-E2 security violated: ${key}`);
        }
    }
    return QXREAD_T8_E2_SECURITY;
}
export const QXREAD_T8_E3_PROHIBITED = [
    'QXRead → silent sync conflict discard',
    'QXRead → invent Entitlement from SyncQueue',
    'QXRead → mutate QXP via SyncQueue',
    'QXRead → execute Flip from SyncQueue surface',
];
export const QXREAD_T8_E3_SECURITY = Object.freeze({
    syncConflictsAreNonSilent: true,
    syncDoesNotInventEntitlement: true,
    syncDoesNotMutateQxp: true,
    syncDoesNotExecuteFlip: true,
});
export function isT8E3ProhibitedOperation(operation) {
    return QXREAD_T8_E3_PROHIBITED.includes(operation);
}
export function assertT8E3SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_E3_SECURITY)) {
        const expected = QXREAD_T8_E3_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8-E3 security violated: ${key}`);
        }
    }
    return QXREAD_T8_E3_SECURITY;
}
export const QXREAD_T8_E4_PROHIBITED = [
    'QXRead → execute Media outside QXReader',
    'QXRead → invent Entitlement from Media intent',
    'QXRead → mutate QXP via Media intent',
];
export const QXREAD_T8_E4_SECURITY = Object.freeze({
    mediaExecutesInQxReaderOnly: true,
    mediaDoesNotInventEntitlement: true,
    mediaDoesNotMutateQxp: true,
    mediaIntentIsNotRuntime: true,
});
export function isT8E4ProhibitedOperation(operation) {
    return QXREAD_T8_E4_PROHIBITED.includes(operation);
}
export function assertT8E4SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_E4_SECURITY)) {
        const expected = QXREAD_T8_E4_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8-E4 security violated: ${key}`);
        }
    }
    return QXREAD_T8_E4_SECURITY;
}
export const QXREAD_T8_E5_PROHIBITED = [
    'QXRead → execute Flip outside QXReader',
    'QXRead → invent Entitlement from Flip intent',
    'QXRead → mutate QXP via Flip intent',
];
export const QXREAD_T8_E5_SECURITY = Object.freeze({
    flipExecutesInQxReaderOnly: true,
    flipDoesNotInventEntitlement: true,
    flipDoesNotMutateQxp: true,
    flipIntentIsNotRuntime: true,
});
export function isT8E5ProhibitedOperation(operation) {
    return QXREAD_T8_E5_PROHIBITED.includes(operation);
}
export function assertT8E5SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_E5_SECURITY)) {
        const expected = QXREAD_T8_E5_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8-E5 security violated: ${key}`);
        }
    }
    return QXREAD_T8_E5_SECURITY;
}
export const QXREAD_T8_E6_PROHIBITED = [
    'QXRead → ignore reduced-motion preference for Flip fallback',
    'QXRead → invent Entitlement from Motion preference',
    'QXRead → execute Flip from Motion preference surface',
];
export const QXREAD_T8_E6_SECURITY = Object.freeze({
    reducedMotionFlipFallbackRequired: true,
    motionDoesNotInventEntitlement: true,
    motionDoesNotExecuteFlip: true,
});
export function isT8E6ProhibitedOperation(operation) {
    return QXREAD_T8_E6_PROHIBITED.includes(operation);
}
export function assertT8E6SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_E6_SECURITY)) {
        const expected = QXREAD_T8_E6_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8-E6 security violated: ${key}`);
        }
    }
    return QXREAD_T8_E6_SECURITY;
}
export const QXREAD_T8_E7_PROHIBITED = [
    'QXRead → ADAM entry without entitlement',
    'QXRead → ADAM entry without Reader context',
    'QXRead → Own ADAM intelligence execution',
    'QXRead → mutate publication via ADAM entry',
    'QXRead → invent Entitlement from ADAM entry',
];
export const QXREAD_T8_E7_SECURITY = Object.freeze({
    adamEntryRequiresEntitlement: true,
    adamEntryRequiresReaderContext: true,
    adamIntelligenceNotOwnedByQxread: true,
    adamDoesNotMutatePublication: true,
    adamDoesNotInventEntitlement: true,
});
export function isT8E7ProhibitedOperation(operation) {
    return QXREAD_T8_E7_PROHIBITED.includes(operation);
}
export function assertT8E7SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T8_E7_SECURITY)) {
        const expected = QXREAD_T8_E7_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T8-E7 security violated: ${key}`);
        }
    }
    return QXREAD_T8_E7_SECURITY;
}
//# sourceMappingURL=advanced-security.js.map